import React, { ReactElement } from "react";

import { Flex } from "@common/styles/reusable/Flex/Flex.styles";

import * as Styled from "./ModalFooter.styles";

export type ModalFooterProps = {
  toggle?: () => void;
  button?: ReactElement;
  buttonText?: string;
  additionalElement?: ReactElement;
  leftButton?: ReactElement;
  hasSeparator?: boolean;
};

export const ModalFooter = ({
  toggle,
  button,
  leftButton,
  additionalElement,
  hasSeparator = true,
  buttonText = "Cancel",
}: ModalFooterProps) => {
  return (
    <Styled.Flex
      $justifyContent="space-between"
      $hasSeparator={hasSeparator}
    >
      <Flex
        $justifyContent="start"
        $alignItems="center"
      >
        {leftButton && leftButton}
      </Flex>
      <Flex
        $justifyContent="flex-end"
        $alignItems="center"
      >
        {additionalElement && additionalElement}
        {toggle ? (
          <Styled.Button
            $hasPaddingRight={button && true}
            styling="outline"
            onClick={toggle}
            size="small"
          >
            {buttonText}
          </Styled.Button>
        ) : null}
        {button && button}
      </Flex>
    </Styled.Flex>
  );
};
